import Legacy from "./Legacy";
import Interactive from "./Interactive";
import { useConfig } from "../../hooks";

const LoadingScreen: React.FC = () => {
  const { loadingScreen: config } = useConfig();
  if (config.type === "interactive") {
    return <Interactive />;
  }

  return <Legacy />;
};

export default LoadingScreen;
